import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Button } from '@mui/material';

import { successToast } from '../../toast';
import { ReturnComponent } from '../../utils/reactTypes';

export const copyToClipboard = async (value: string) => {
    await navigator.clipboard.writeText(value);
    successToast('Copied!', { deduplicate: false });
};

export const CopyButton = ({
    value,
    withTextLabel = false,
}: {
    value: string;
    withTextLabel?: boolean;
}): ReturnComponent => {
    return (
        <Button
            variant={'text'}
            color={'secondary'}
            disableElevation
            startIcon={<FileCopyIcon />}
            size='small'
            sx={{
                textTransform: 'capitalize',
            }}
            onClick={() => void copyToClipboard(value)}
        >
            {withTextLabel ? 'Copy' : ''}
        </Button>
    );
};
